import React, { Component } from 'react';
import { Map, Marker, Popup } from '2gis-maps-react';

import './style.css';


export default class CustomMap extends Component {
  render() {
    return (
      <div>
        <div className='map'>
          <div className='map__title'>место проведения</div>
          <div className='map__info'>Омск, просп. Мира, 55а, ОмГУ им. Ф.М.Достоевского</div>
        </div>
        <Map
            style={{height: '341px', width: '100%'}}
            center={[55.02837756968916,73.26184249999991]}
            zoom={16}
            scrollWheelZoom={false}
        >
          <Marker
              pos={[55.02837756968916,73.26184249999991]}
          >
            <Popup maxWidth={150} sprawling={true}>
              ОмГУ им. Ф.М.Достоевского
            </Popup>
          </Marker>
        </Map>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout-page/blocks/map/Map.js